import getAssets from "api/public/asset";

export const getCompanyAssets = (companyId) => (dispatch, getState) => {
  const assets = getState().companyAssets.filter((a) => a.companyId === parseInt(companyId, 10));
  if (assets.length) return null;

  return dispatch({
    type: "COMPANY_ASSETS_PUBLIC_GET",
    payload: getAssets(companyId),
  });
};

export default getCompanyAssets;
